import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseService } from 'src/services/core/base/base.service';
import { Response } from 'src/services/classes/models/response.interface';

const routes = {
  updateProfile: 'api/v1/users/waiter',
  changePassword: 'api/v1/users/update-password',
};

@Injectable({
  providedIn: 'root',
})
export class AccountService extends BaseService<any> {
  constructor(public http: HttpClient) {
    super(http);
  }

  updateProfile(payload: any): Observable<Response> {
    return this.sendPut(this.baseUrl(routes.updateProfile), payload);
  }

  changePassword(payload: any): Observable<Response> {
    return this.sendPut(this.baseUrl(routes.changePassword), payload);
  }
}
